// @ts-nocheck
import React from 'react';

const ShippingAccountDeleteAlert = React.lazy(
  () => import('@/containers/Alerts/ShippingAccount/ShippingAccountDeleteAlert'),
);

export default [
  { name: 'shipping-account-delete', component: ShippingAccountDeleteAlert },
];
